import 'reflect-metadata';
import {jsonObject, jsonMember, jsonArrayMember} from 'typedjson';

export enum ClientAuthenticationMethod {
  Certificate,
  Token,
}

@jsonObject
export class LoraForwarderBasicStationServerConfig {
  @jsonMember
  public enabled: boolean = false;

  @jsonMember
  public protocol!: string;
  @jsonMember
  public address!: string;
  @jsonMember
  public port!: string;

  @jsonMember
  public tlsEnabled: boolean = false;

  @jsonMember
  public serverCertificate: string | null = null;

  @jsonMember
  public clientAuthenticationEnabled: boolean = false;

  @jsonMember
  public clientAuthenticationMethod!: ClientAuthenticationMethod;

  @jsonMember
  public clientCertificate: string | null = null;
  @jsonMember
  public clientKey: string = '';
  @jsonMember
  public clientToken: string = '';
}
